import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from "@src/environments/environment";

export interface BolhaLocationDetail {
    bolha_id: number;
    region: string;
    city: string;
    place: string;
}

export interface BolhaPlace {
    bolha_id: number;
    name: string;
}

@Injectable({ providedIn: 'root' })
export class BolhaLocationApiService {
    private readonly baseUrl = `${environment.apiUrl}/api/integrations/bolha/locations`;

    constructor(private http: HttpClient) {}

    getRegions(): Observable<string[]> {
        return this.http.get<string[]>(`${this.baseUrl}/regions`);
    }

    getCities(region: string): Observable<string[]> {
        return this.http.get<string[]>(`${this.baseUrl}/regions/${encodeURIComponent(region)}/cities`);
    }

    getPlaces(city: string, region: string): Observable<BolhaPlace[]> {
        const params = new HttpParams().set('region', region);
        return this.http.get<BolhaPlace[]>(`${this.baseUrl}/cities/${encodeURIComponent(city)}/places`, { params });
    }

    getLocation(bolhaId: number): Observable<BolhaLocationDetail> {
        return this.http.get<BolhaLocationDetail>(`${this.baseUrl}/${bolhaId}`);
    }
}
